<template>
  <el-date-picker
    v-model="date"
    style="width: 100%"
    type="daterange"
    range-separator="-"
    :start-placeholder="title + '开始日期'"
    :end-placeholder="title + '结束日期'"
    @change="onChange">
  </el-date-picker>
</template>
<script>
export default {
  name: 'DateRangeSelect',
  props: {
    callback: Function,
    title: {
      type: String,
      default: '交易'
    },
    value: {
      required: true
    }
  },
  data() {
    return { }
  },
  computed: {
    date: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange() {
      this.callback && this.callback()
    }
  }
}
</script>
